/* eslint-disable import/prefer-default-export */

export const curriculumsAndSubjectsForDiagnosticChallenge = {
  'Cambridge IGCSE': [
    'Additional Maths',
    'Biology',
    'Business Studies',
    'Chemistry',
    'Computer Science',
    'Coordinated Science',
    'Economics',
    'English Language',
    'Mathematics',
    'Physics',
  ],
  'Edexcel IGCSE': [
    'Biology',
    'Business Studies',
    'Chemistry',
    'Economics',
    'Mathematics',
    'Physics',
  ],
  'Cambridge International A Levels': [
    'Biology',
    'Chemistry',
    'Mathematics',
    'Physics',
  ],
  'Edexcel International A Levels': [
    'Biology',
    'Chemistry',
    'Mathematics',
    'Physics',
  ],
};

export const isDiagnosticChallengeEligible = (
  curriculum?: string,
  subject?: string
): boolean =>
  Boolean(
    curriculum &&
      subject &&
      curriculumsAndSubjectsForDiagnosticChallenge[
        curriculum as keyof typeof curriculumsAndSubjectsForDiagnosticChallenge
      ]?.includes(subject)
  );
